// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lesson-plan-preview {
    background: #fefdf7;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
    font-family: 'Segoe UI', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    max-width: 600px;
}
  
.lesson-slide {
    background: #fff;
    border: 2px solid;
    border-left: 6px solid;
    border-radius: 10px;
    padding: 20px;
    animation: fadeIn 0.4s ease;
    width: 100%;
    text-align: center;
}
  
/* Dimension-specific styles */
.lesson-slide[data-dimension="Explore"] {
    border-color: #f4a460;
    border-left-color: #ffd700;
    background: linear-gradient(135deg, rgba(244, 164, 96, 0.1) 0%, rgba(255, 215, 0, 0.1) 100%);
}
  
.lesson-slide[data-dimension="Compare"] {
    border-color: #66cdaa;
    border-left-color: #20b2aa;
    background: linear-gradient(135deg, rgba(102, 205, 170, 0.1) 0%, rgba(32, 178, 170, 0.1) 100%);
}
  
.lesson-slide[data-dimension="Question"] {
    border-color: #f08080;
    border-left-color: #ff6347;
    background: linear-gradient(135deg, rgba(240, 128, 128, 0.1) 0%, rgba(255, 99, 71, 0.1) 100%);
}
  
.lesson-slide[data-dimension="Connect"] {
    border-color: #90ee90;
    border-left-color: #32cd32;
    background: linear-gradient(135deg, rgba(144, 238, 144, 0.1) 0%, rgba(50, 205, 50, 0.1) 100%);
}
  
.lesson-slide[data-dimension="Appreciate"] {
    border-color: #dda0dd;
    border-left-color: #ba55d3;
    background: linear-gradient(135deg, rgba(221, 160, 221, 0.1) 0%, rgba(186, 85, 211, 0.1) 100%);
}
  
.lesson-slide-header {
    font-size: 1rem;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 12px;
    text-align: center;
}
  
/* Dimension-specific header colors */
.lesson-slide[data-dimension="Explore"] .lesson-slide-header {
    color: #ffd700;
}
  
.lesson-slide[data-dimension="Compare"] .lesson-slide-header {
    color: #20b2aa;
}
  
.lesson-slide[data-dimension="Question"] .lesson-slide-header {
    color: #ff6347;
}
  
.lesson-slide[data-dimension="Connect"] .lesson-slide-header {
    color: #32cd32;
}
  
.lesson-slide[data-dimension="Appreciate"] .lesson-slide-header {
    color: #ba55d3;
}
  
.lesson-slide p {
    font-size: 0.95rem;
    color: #333;
    line-height: 1.5;
    text-align: center;
    margin: 0 auto;
}
  
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
}
  `, "",{"version":3,"sources":["webpack://./src/home/Tools/LessonPlanPreview.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,4FAA4F;AAChG;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,8FAA8F;AAClG;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,6FAA6F;AACjG;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,6FAA6F;AACjG;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,8FAA8F;AAClG;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,qCAAqC;AACrC;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD","sourcesContent":[".lesson-plan-preview {\n    background: #fefdf7;\n    padding: 20px;\n    border-radius: 12px;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n    font-family: 'Segoe UI', sans-serif;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    max-width: 600px;\n}\n  \n.lesson-slide {\n    background: #fff;\n    border: 2px solid;\n    border-left: 6px solid;\n    border-radius: 10px;\n    padding: 20px;\n    animation: fadeIn 0.4s ease;\n    width: 100%;\n    text-align: center;\n}\n  \n/* Dimension-specific styles */\n.lesson-slide[data-dimension=\"Explore\"] {\n    border-color: #f4a460;\n    border-left-color: #ffd700;\n    background: linear-gradient(135deg, rgba(244, 164, 96, 0.1) 0%, rgba(255, 215, 0, 0.1) 100%);\n}\n  \n.lesson-slide[data-dimension=\"Compare\"] {\n    border-color: #66cdaa;\n    border-left-color: #20b2aa;\n    background: linear-gradient(135deg, rgba(102, 205, 170, 0.1) 0%, rgba(32, 178, 170, 0.1) 100%);\n}\n  \n.lesson-slide[data-dimension=\"Question\"] {\n    border-color: #f08080;\n    border-left-color: #ff6347;\n    background: linear-gradient(135deg, rgba(240, 128, 128, 0.1) 0%, rgba(255, 99, 71, 0.1) 100%);\n}\n  \n.lesson-slide[data-dimension=\"Connect\"] {\n    border-color: #90ee90;\n    border-left-color: #32cd32;\n    background: linear-gradient(135deg, rgba(144, 238, 144, 0.1) 0%, rgba(50, 205, 50, 0.1) 100%);\n}\n  \n.lesson-slide[data-dimension=\"Appreciate\"] {\n    border-color: #dda0dd;\n    border-left-color: #ba55d3;\n    background: linear-gradient(135deg, rgba(221, 160, 221, 0.1) 0%, rgba(186, 85, 211, 0.1) 100%);\n}\n  \n.lesson-slide-header {\n    font-size: 1rem;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 12px;\n    text-align: center;\n}\n  \n/* Dimension-specific header colors */\n.lesson-slide[data-dimension=\"Explore\"] .lesson-slide-header {\n    color: #ffd700;\n}\n  \n.lesson-slide[data-dimension=\"Compare\"] .lesson-slide-header {\n    color: #20b2aa;\n}\n  \n.lesson-slide[data-dimension=\"Question\"] .lesson-slide-header {\n    color: #ff6347;\n}\n  \n.lesson-slide[data-dimension=\"Connect\"] .lesson-slide-header {\n    color: #32cd32;\n}\n  \n.lesson-slide[data-dimension=\"Appreciate\"] .lesson-slide-header {\n    color: #ba55d3;\n}\n  \n.lesson-slide p {\n    font-size: 0.95rem;\n    color: #333;\n    line-height: 1.5;\n    text-align: center;\n    margin: 0 auto;\n}\n  \n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
